import { v4 as uuidv4 } from 'uuid';

export const predefinedColors = [
  '#8B5E3C', '#C85D5D', '#D4A659', '#7E9B80', '#5D7290',
  '#9E7BB5', '#D08060', '#C9B27C', '#889E6D', '#6B8B9C'
];

export const predefinedIcons = [
  'home', 'folder', 'code-view', 'edit', 'settings', 'save', 'refresh', 'clock',
  'lock', 'search', 'bookmark', 'delete-1', 'circle-add', 'paste',
  'link', 'circle-info', 'user', 'people', 'radio-button', 'user-defined',
  'rectangle', 'justify', 'circle-check', 'comment-show', 'print-layout',
  'volume', 'chevron-left-double', 'flags', 'objects', 'sorting-1', 'trash',
  'plus', 'cut', 'filter', 'signature'
];

export const defaultWorkspace = {
  name: 'New Tab',
  uuid: uuidv4(),
  data: null,
  isNewTab: false,
  isOpen: true,
  isActive: true,
  isPending: false,
  group: '',
  groupColor: '',
  widgets: {
    widgets: [],
    layout: {},
    oldWidgetViewType: null
  }, 
  breadcrumb: {
    shiftHelper: [],
    historyPages: [],
    currentPage: null,
  },
  modals: {
    imageDialog: {
      isOpen: false,
      params: null
    },
    confirmModal: {
      isOpen: false,
    },
    title: null,
    content: null,
    imageEvent: null,
    linkEvent: null,
    eventType: null,
    selectedText: '',
    multiUpload: {
      isOpen: false,
      widgetData: {}
    },
    dialog: {
      isOpen: false
    },
    modal: {
      isOpen: false
    }
  },
  chat: {
    isOpen: false,
    id: null,
    posts: [],
    filterMode: false
  },
  navigation: {
    modules: [],
    treeData: []
  }
};